module.exports = __webpack_public_path__ + "img/cupom.ca981392.png";